var isNil = require('./isNil');
var isString = require('./isString');

module.exports = function isTypeName(name) {
  return isNil(name) || isString(name);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/tcomb/lib/isTypeName.js
// module id = 44
// module chunks = 0